/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import Tooltip from "@material-ui/core/Tooltip";
import StepButton from "@material-ui/core/StepButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import makeStyles from "@material-ui/core/styles/makeStyles";

import StepNumber from "common/assets/step-number";
import steps from "features/budget/wizard/state/stepper.data";
import { BUDGET_STEPS_ROUTES } from "features/budget/budget.sections";
import stepperStyles from "features/budget/wizard/views/stepper/stepper.styles";

const useStyles = makeStyles(stepperStyles);

function BudgetSteps({ activeStep, isLargeScreen }) {
  const stepperRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const link = (step) => {
    const linkStep = BUDGET_STEPS_ROUTES[step];
    const LinkComponent = forwardRef((props, ref) => (
      <RouterLink ref={ref} to={linkStep} {...props} />
    ));
    LinkComponent.displayName = "routeStep";
    return LinkComponent;
  };

  const handleExpandClick = () => {
    setAnchorEl(stepperRef.current);
  };

  const handleMenuItemClick = () => {
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  if (isLargeScreen) {
    return (
      <Stepper
        activeStep={activeStep}
        connector={null}
        className={classes.stepper}
      >
        {steps.map((step) => (
          <Step key={step.key}>
            <StepButton component={link(step.key)}>
              <Tooltip title={step.tooltip} placement="top">
                <span>{step.caption}</span>
              </Tooltip>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    );
  }

  return (
    <>
      <Stepper
        ref={stepperRef}
        onClick={handleExpandClick}
        activeStep={activeStep}
        connector={null}
        className={classes.stepper}
      >
        {steps.map((step) => (
          <Step
            key={step.key}
            className={step.key !== activeStep ? classes.hidden : null}
          >
            <StepButton>
              <Tooltip title={step.tooltip} placement="top">
                <span>{step.caption}</span>
              </Tooltip>
            </StepButton>
          </Step>
        ))}
      </Stepper>

      <IconButton aria-label="expand all steps" onClick={handleExpandClick}>
        <ExpandMoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        {steps
          .filter(({ key }) => key !== activeStep)
          .map((step) => (
            <MenuItem
              component={link(step.key)}
              key={step.key}
              selected={step.key === activeStep}
              onClick={handleMenuItemClick}
              disabled={step.key > activeStep}
            >
              <ListItemIcon>
                <StepNumber number={step.key + 1} />
              </ListItemIcon>
              <ListItemText primary={step.caption} />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}

BudgetSteps.propTypes = {
  activeStep: PropTypes.number.isRequired,
  isLargeScreen: PropTypes.bool.isRequired,
};

export default BudgetSteps;
